import * as React from "react";
import { Modal,Button,Radio,Input, Table} from "antd";
import { connect } from "react-redux";
import { getOldHost } from "utils/tool";
import { EUrl, orderDetailUrl } from "utils/enum/url";
const { TextArea } = Input;
const RadioGroup = Radio.Group;
interface IDeviationProps {
  id:any;
  submitTag:any;
  getOrderDetails:any;
  paymentList:any;
  getRemarkList:any;
}

// 确认函
class Deviation extends React.Component<IDeviationProps, any> {
  state = {
    visible:false,
    content:'add_remark',
    beizhu:'',
  };
  constructor(props: IDeviationProps) {
    super(props);
  }

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }
  
  show(id) {
    this.setState({
      visible:true
    })
  }

  onChange =(value) => {
    this.setState({
      content:value.target.value
    })     
  }

  onChangebeizhu =(value) => {
    this.setState({
      beizhu:value.target.value
    })     
  }


  onOk= () =>{
     if(this.state.content == 'add_discount'){
        window.open(getOldHost()+"/report/sale_discount/addDiscount/"+this.props.id);
        this.handleCancel();
        return;   
     }
     const param: any = {
      id: this.props.id,
      type: 'cha',
      chaRemark:this.state.beizhu
    }; 
    this.props.submitTag({
      ...param,
      callback: (data) => {
          this.handleCancel();
          const params: any = {
            id: this.props.id
          }; 
          this.props.getOrderDetails({
            ...params,
            callback: () => {
            }
           });
          this.props.getRemarkList({
            ...params,
            callback: () => {
            }
           });
          this.setState({
            beizhu:''
          })
      }
     }); 
  }

  render() {
    const buttonStyle = {
      backgroundColor: "#fff",
      color:"#000",
      border:'none',
      display: 'block',
    };
    const columns: any = [
      {
        title: '',
        dataIndex: 'type',
        key: 'type',
        width: 100,
        className:'th',
        align: 'center'
      },
      {
        title: '订单编号',
        dataIndex: 'number',
        key: 'number',
        width: 160,
        className:'th',
        render: (text, row, index) => {
          console.log(this.props.id);
          console.log(row);
          return (
            <a href={orderDetailUrl(EUrl.orderDetail, this.props.id)} target="_blank">{text}</a>
          );
        }
      },
      {
        title: '数量',
        dataIndex: 'num',
        key: 'num',
        width: 60,
        className:'th',
        align: 'center'
      },
      {
        title: '数量销售单价(￥)',
        dataIndex: 'price',
        key: 'price',
        width: 80,
        className:'th',
        align: 'center'
      },
      {
        title: '成人',
        dataIndex: 'adult_num',
        key: 'adult_num',
        width: 60,
        className:'th',
        align: 'center'
      },
      {
        title: '成人销售单价(￥)',
        dataIndex: 'adult_price',
        key: 'adult_price',
        width: 80,
        className:'th',
        align: 'center'
      },
      {
        title: '儿童',
        dataIndex: 'children_num',
        key: 'children_num',
        width: 60,
        className:'th',
        align: 'center'
      },
      {
        title: '儿童销售单价(￥)',
        dataIndex: 'child_price',
        key: 'child_price',
        width: 80,
        className:'th',
        align: 'center'
      },
      {
        title: '总销售金额(￥)',
        dataIndex: 'sale_amount',
        key: 'sale_amount',
        width: 80,
        className:'th',
        align: 'center'
      },
      {
        title: '交通附加费(￥)',
        dataIndex: 'surcharge_amount',
        key: 'surcharge_amount',
        width: 80,
        className:'th',
        align: 'center'
      },
      {
        title: '优惠券抵扣金额(￥)',
        dataIndex: 'discount_fee',
        key: 'discount_fee',
        width: 80,
        className:'th',
        align: 'center'
      },
      {
        title: '商业折扣(￥)',
        dataIndex: 'part_mjz_discount',
        key: 'part_mjz_discount',
        width: 80,
        className:'th',
        align: 'center'
      },
      {
        title: '积分抵扣金额(￥)',
        dataIndex: 'point_fee',
        key: 'point_fee',
        width: 80,
        className:'th',
        align: 'center'
      },
      {
        title: '实付金额(￥)',
        dataIndex: 'payment',
        key: 'payment',
        width: 80,
        className:'th',
        align: 'center'
      }];
    return (
      <React.Fragment>
      <Button style={buttonStyle} onClick={this.show.bind(this,this.props.id)}>退差</Button> 
      <Modal maskClosable={false} onOk={this.onOk} onCancel={this.handleCancel} title="退差"  visible={this.state.visible}  width="auto" centered={true}>
          <div className="abnormal">
           <RadioGroup onChange={this.onChange} value={this.state.content}>
           <Radio value="add_discount">添加优惠记录</Radio>
           <Radio value="add_remark">添加退款备注</Radio>
           </RadioGroup>
          </div>
          {this.state.content == 'add_remark' ? 
          <div className="tui-bei"> 
            <TextArea placeholder="退款备注" value={this.state.beizhu} onChange={this.onChangebeizhu}  rows={5} />
            <Table className="ddd" bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1} pagination={false} 
            dataSource={this.props.paymentList} columns={columns} />
          </div> 
        : ''}
      </Modal> 
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
  paymentList: state.orderDetails.paymentList,
});

const mapDispatch = dispatch => {
  return {
    submitTag:dispatch.orderDetails.submitTag,
    getOrderDetails: dispatch.orderDetails.getOrderDetails,
    getRemarkList: dispatch.orderDetails.getRemarkList
  };
};

export default connect(
  mapState ,
  mapDispatch
)(Deviation);
